import React, { useContext, useState } from "react";
import { GlobalContex } from "../context/globalContext";
import { addOnsData } from "../constants/addOnsData";
import check from "../assets/images/icon-thank-you.svg";

// Tattoo & Piercing Pricing Options
const pricingOptions = {
  Tattoos: [
    { id: "tattoo1", label: "Small Tattoo (1-2 inches)", price: "$50 - $100" },
    { id: "tattoo2", label: "Medium Tattoo (3-5 inches)", price: "$150 - $300" },
    { id: "tattoo3", label: "Large Tattoo (6+ inches)", price: "$350+" },
    { id: "tattoo4", label: "Custom Design", price: "Contact for quote" },
  ],
  Piercings: [
    { id: "piercing1", label: "Ear Piercing", price: "$30" },
    { id: "piercing2", label: "Nose Piercing", price: "$40" },
    { id: "piercing3", label: "Eyebrow Piercing", price: "$50" },
    { id: "piercing4", label: "Belly Button Piercing", price: "$60" },
  ],
  Extras: [
    { id: "extra1", label: "Touch-up (existing clients)", price: "$20+" },
    { id: "extra2", label: "Aftercare Kit", price: "$15" },
  ],
};

const Summary = () => {
  const {
    selectedPlan,
    selectedAddOn,
    monthlyPlan,
    getTotalAmount,
    setCurrentStep,
    formCompeleted,
  } = useContext(GlobalContex);

  const plansSelected = [selectedPlan];
  const totalAmount = getTotalAmount();

  // Modal logic
  const [modalType, setModalType] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    Tattoos: "",
    Piercings: "",
    Extras: "",
  });
  const [addonNotes, setAddonNotes] = useState("");

  const handleOptionChange = (type, id) => {
    setSelectedOptions((prev) => ({ ...prev, [type]: id }));
  };

  const closeModal = () => setModalType(null);

  const renderModalContent = (type) => (
    <div className="bg-white rounded-lg w-[90%] md:w-[500px] p-6 relative shadow-xl max-h-[80vh] overflow-y-auto">
      <button
        onClick={closeModal}
        className="absolute top-3 right-4 text-2xl font-bold text-gray-600 hover:text-black"
      >
        &times;
      </button>
      <h2 className="text-2xl font-semibold text-primary-marineBlue mb-4">
        {type} Options
      </h2>
      <form className="space-y-4">
        {pricingOptions[type].map((option) => (
          <label
            key={option.id}
            className="flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:bg-gray-50"
          >
            <div className="flex items-center gap-3">
              <input
                type="radio"
                name={type}
                value={option.id}
                checked={selectedOptions[type] === option.id}
                onChange={() => handleOptionChange(type, option.id)}
                className="accent-primary-purplishBlue"
              />
              <span>{option.label}</span>
            </div>
            <span className="font-medium text-primary-purplishBlue">
              {option.price}
            </span>
          </label>
        ))}
      </form>
    </div>
  );

  return (
    <>
      {formCompeleted ? (
        <div className="h-full flex justify-center items-center">
          <div className="text-center">
            <div className="flex items-center justify-center">
              <img src={check} alt="check svg" />
            </div>
            <div className="mt-5">
              <h1 className="text-primary-marineBlue font-bold text-[1.6rem] md:text-4xl leading-9">
                Thank you!
              </h1>
              <p className="mt-5 text-gray-400">
                Thanks for confirming your subscription! We hope you have fun using our platform. If you ever need support, please feel free to email us at support@loremgaming.com.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <h1 className="text-primary-marineBlue font-bold text-[1.6rem] md:text-3xl leading-9">
          TATTOO & PIERCING WAIVER
          </h1>
          <h3 className="text-gray-400 mt-2">
          At our studio, we believe in transparent, fair pricing that reflects the quality and experience you receive. Below are general price ranges for our tattoo, piercing, and add-on services. Final pricing may vary based on size, placement, complexity, and custom designs.
          </h3>

          <div className="md:mt-7 mt-5" style={{}}>
            <div className="rounded-lg bg-secondary-alabaster p-5" style={{
              display:"none"
            }}>
              {plansSelected.map((data, index) => {
                const { title, monthlyFee, yearlyFee } = data;

                return (
                  <div key={index} className="plan_check" style={{
                    display:"none"
                  }}>
                    <div className="flex items-center">
                      <div className="mr-auto">
                        <h3 className="text-primary-marineBlue md:text-lg text-[16px] font-medium">
                          {title} ({monthlyPlan ? "Monthly" : "Yearly"})
                        </h3>
                        <button
                          onClick={() => setCurrentStep(2)}
                          className="bg-transparent duration-700 p-0 border-0 outline-none text-gray-400 md:text-[16px] text-sm hover:text-primary-purplishBlue underline"
                          style={{
                            display:"none"
                          }}
                        >
                          Change
                        </button>
                      </div>

                      <div>
                        <h3 className="text-primary-marineBlue md:text-lg text-[16px] font-bold">
                          ${monthlyPlan ? monthlyFee : yearlyFee}/{monthlyPlan ? "mo" : "yr"}
                        </h3>
                      </div>
                    </div>
                  </div>
                );
              })}

              <hr className="bg-secondary-lightGray my-5" />

              <div className="add-ons_check space-y-2">
                {addOnsData.map((data, index) => {
                  const { id, title, monthlyFee, yearlyFee } = data;

                  if (selectedAddOn[id] !== 0) {
                    return (
                      <div key={index} className="flex items-center">
                        <div className="mr-auto">
                          <div className="text-gray-400 md:text-[16px] text-sm">
                            {title}
                          </div>
                        </div>
                        <div className="text-primary-marineBlue md:text-[16px] text-sm font-medium">
                          +${monthlyPlan ? monthlyFee : yearlyFee}/{monthlyPlan ? "mo" : "yr"}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>

            {/* Pricing Popup Trigger Buttons */}
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 my-8">
              {["Tattoos", "Piercings", "Extras"].map((type) => (
                <button
                  key={type}
                  onClick={() => setModalType(type)}
                  className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition w-60 text-center"
                >
                  View <br /> {type}
                </button>
              ))}
            </div>

            {/* Add-ons / Notes Section */}
            <div className="max-w-xl mx-auto text-left mb-6">
              <label className="block text-gray-700 font-medium mb-2 text-lg">
                Add-ons or Notes
              </label>
              <textarea
                value={addonNotes}
                onChange={(e) => setAddonNotes(e.target.value)}
                placeholder="Let us know any custom requests, design instructions, or pricing conditions..."
                className="w-full border rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-primary-purplishBlue"
                rows={2}
              />
            </div>

            <div className="p-4" style={{
              display:"none"
            }}>
              <div className="flex items-center">
                <div className="mr-auto md:text-[16px] text-sm text-gray-400">
                  Total ({monthlyPlan ? "per month" : "per year"})
                </div>
                <div>
                  <h3 className="text-primary-purplishBlue font-bold md:text-[19px] tet-[18px]">
                    {monthlyPlan ? "+" : null}${totalAmount}/{monthlyPlan ? "mo" : "yr"}
                  </h3>
                </div>
              </div>

              {/* Confirm Button */}
              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setCurrentStep(5)}
                  className="bg-primary-purplishBlue text-white px-6 py-3 rounded-lg hover:bg-primary-purplishBlue/90 transition"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {modalType && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center">
          {renderModalContent(modalType)}
        </div>
      )}
    </>
  );
};

export default Summary;
